/**
 * AthleteSubscribeWidget
 * ----------------------
 * Per-athlete Subscribe action — Spotify-Plan / Sub-account model
 * (Sachin 2026-02-27). Renders on the athlete dossier Billing tab
 * AND inline-expanded under each athlete row in the Main account
 * Lead Detail. Every charge is hard-pinned to a single athlete; the
 * family card on file pays.
 *
 * Implementation note: this is a thin wrapper around the existing
 * SubscribeFromBlock — we just force the athletes prop to a single-
 * element list so the athlete picker disappears and the chosen
 * athlete is implicit.
 */
import SubscribeFromBlock from "./SubscribeFromBlock";

export default function AthleteSubscribeWidget({
    parentUserId,       // user_id of the main account (the parent)
    athleteId,
    athleteFirstName,
    athleteLastName,
    onSubscribed,
}) {
    if (!parentUserId || !athleteId) {
        return (
            <div className="text-[11px] text-zinc-500 italic px-3 py-2 border border-zinc-800">
                Missing account/athlete context — can&apos;t subscribe.
            </div>
        );
    }
    // Pinned single-athlete list. SubscribeFromBlock auto-selects the
    // only entry and hides the picker (`athletes.length > 1` check).
    const pinned = [{
        athlete_id: athleteId,
        first_name: athleteFirstName || "Athlete",
        last_name: athleteLastName || "",
        name: `${athleteFirstName || "Athlete"} ${athleteLastName || ""}`.trim(),
    }];
    return (
        <div data-testid={`athlete-subscribe-widget-${athleteId}`} className="space-y-3">
            <div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500">
                Subscribing <span className="text-emerald-300">{pinned[0].name}</span> — charges land on the family card on file.
            </div>
            <SubscribeFromBlock
                userId={parentUserId}
                athletes={pinned}
                onSubscribed={onSubscribed}
            />
        </div>
    );
}
